let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '充电桩显示名称',
        props: 'showName',
        minWidth: 200,
    },
    {
        label: '充电桩型号',
        props: 'mobile',
        minWidth: 200,
    },
    {
        label: '充电桩编号',
        props: 'registerType',
        minWidth: 120,
    },
    {
        label: '充电桩IMEI编号',
        props: 'registerSource',
        minWidth: 200,
    },
    {
        label: '成品料号',
        props: 'registerSource',
        minWidth: 200,
    },
    {
        label: '厂商代码',
        props: 'registerTime',
        minWidth: 200,
        sortable:true,
    },    
    {
        label: '软件版本',
        props: 'latestChargeDate',
        minWidth: 200,
    },
    {
        label: '支持协议',
        props: 'latestChargeDate',
        minWidth: 200,
    },
    {
        label: '电流输出类型',
        props: 'latestChargeDate',
        minWidth: 200,
    },
    {
        label: '单项桩/三项桩',
        props: 'latestChargeDate',
        minWidth: 200,
    },
    {
        label: '功率',
        props: 'latestChargeDate',
        minWidth: 200,
    },
    {
        label: '所属用户',
        props: 'latestChargeDate',
        minWidth: 200,
    },
];

// 列表展示项
pageConfig.dialogListColumns = [
    {
        label: '标签名称',
        props: 'configName',
        minWidth: 200,
    },
    {
        label: '创建人',
        props: 'createdByName',
        minWidth: 300,
        tooltip:true,
    },
    {
        label: '标签数量',
        props: 'configDisp',
        minWidth: 200,
    },
];

// 列表展示项
pageConfig.custDetailColumns = [
    {
        label: '操作时间',
        props: 'lastModifiedWhen',
        minWidth: 200,
    },
    {
        label: '充值金额（元）',
        props: 'inExpAmount',
        minWidth: 200,
        tooltip:true,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.operateType == '01') {
                return row.inExpAmount;
            }
            else {
                return ''
            }
        }
    },
    {
        label: '退款金额（元）',
        props: 'inExpAmount',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.operateType == '07') {
                return row.inExpAmount;
            }
            else {
                return ''
            }
        }
    },
    {
        label: '账户剩余金额（元）',
        props: 'changeFreeBal',
        minWidth: 200,
    },
    {
        label: '操作人',
        props: 'lastModifiedByName',
        minWidth: 200,
    },
    {
        label: '备注',
        props: 'remark',
        minWidth: 200,
    },
];

// 列表展示项
pageConfig.custkWhDetailColumns = [
    {
        label: '度电',
        props: 'chargeValue',
        minWidth: 200,
    },
    {
        label: '账户剩余度电',
        props: 'chargeBalanceValue',
        minWidth: 200,
        // tooltip:true,
        // formatter: function formatter(row, column, cellValue, index) {
        //     // 做判断
        //     if (row.operateType == '01') {
        //         return row.inExpAmount;
        //     }
        //     else {
        //         return ''
        //     }
        // }
    },
    {
        label: '操作人',
        props: 'createdByName',
        minWidth: 200,
        // formatter: function formatter(row, column, cellValue, index) {
        //     // 做判断
        //     if (row.operateType == '07') {
        //         return row.inExpAmount;
        //     }
        //     else {
        //         return ''
        //     }
        // }
    },
    {
        label: '操作时间',
        props: 'createdWhen',
        minWidth: 200,
    },
    {
        label: '备注',
        props: 'remark',
        minWidth: 200,
    },
];

// 车辆信息列表
pageConfig.carsListColumns = [
    {
        label: '用户手机号',
        props: 'custPhone',
        minWidth: 200,
    },
    {
        label: '所属地区',
        props: 'vehicleRegion',
        minWidth: 200,
    },
    {
        label: '车辆型号',
        props: 'vehicleModel',
        minWidth: 200,
    },
    {
        label: '车牌号',
        props: 'vehicleNumber',
        minWidth: 200,
    },
    {
        label: '图片',
        props: '',
        minWidth: 200,
    },
    {
        label: '创建时间',
        props: '',
        minWidth: 200,
    },
]

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '客户管理'
},];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: false,
};

// dialog列表-表格属性
pageConfig.dialogTableConfig = {
    showSelection: false,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

// 列表-分页参数
pageConfig.detailPagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 车辆信息 - 分页参数
pageConfig.carPagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileModelDetail',
};

// 路由
pageConfig.listRouter = 'custManageList';

pageConfig.custDeatilRouter = 'custDetail';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'router',
    name: '客户管理',
    router: 'custManageList'
},
{
    type: 'title',
    name: '客户详情',
}];

pageConfig.formRules = {
    pileTypeName: [{
        required: true,
        message: '请填写充电桩型号名称',
        trigger: 'blur'
    }],
};

pageConfig.labelFormRules = {
    configName: [{
        required: true,
        message: '请填写标签名称',
        trigger: 'blur'
    }],
    configVal: [{
        required: true,
        message: '请填写编号',
        trigger: 'blur'
    }],
};

pageConfig.dealerFormRules = {
    dealerNo: [{
        required: true,
        message: '请填写运营商全称',
        trigger: 'blur'
    }],
    mobile: [{
        required: true,
        message: '请填写客户手机号',
        trigger: 'blur'
    },
    {
        pattern: /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
        message: '手机号填写错误',
        trigger: 'blur'
    }],
};

pageConfig.selectFormRules = {
    remark: [{
        required: true,
        message: '请填写备注',
        trigger: 'blur'
    }],
    chargeValue: [
        {
        required: true,
        message: '请输入充值度电',
        trigger: 'blur'
    }
    ],
};

pageConfig.remarkFormRules = {
    remark: [{
        required: true,
        message: '请填写备注',
        trigger: 'blur'
    }],
};

export default pageConfig;